module.exports = __webpack_public_path__ + "static/media/FratPakPrivacyPolicy.24bc2994.pdf";